import { render, staticRenderFns } from "./DeliveryMenuDriftView.vue?vue&type=template&id=6726a803&scoped=true"
import script from "./DeliveryMenuDriftView.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuDriftView.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuDriftView.vue?vue&type=style&index=0&id=6726a803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6726a803",
  null
  
)

export default component.exports